import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PlantInfo {
  customer: string;
  site: string;
  plantName: string;
  status: 'Active' | 'Inactive';
  customerId?: string;
  customerName?: string;
  siteId?: string;
  siteName?: string;
}

export interface PlantState {
  plantInfo: PlantInfo | null;
  sites: Array<{ site: string; siteId: string }>;
}

const initialState: PlantState = {
  plantInfo: null,
  sites: [],
};

const plantSlice = createSlice({
  name: 'plant',
  initialState,
  reducers: {
    setPlantInfo: {
      reducer(state, action: PayloadAction<PlantInfo>) {
        state.plantInfo = action.payload;
      },
      prepare(plantInfo: PlantInfo) {
        return { payload: plantInfo };
      }
    },
    setSites(state, action: PayloadAction<Array<{ site: string; siteId: string }>>) {
      state.sites = action.payload;
    },
    clearPlantState(state) {
      state.plantInfo = null;
      state.sites = [];
    },
  },
});

export const { setPlantInfo, setSites, clearPlantState } = plantSlice.actions;
export default plantSlice.reducer;
